import dayjs from 'dayjs'

const CURRENCY_LABELS = /amount|fee|balance|rate|total|price|cost|credit|debit|subtotal|tax|discount|interest/i
const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}/
const DATETIME_PATTERN = /^\d{4}-\d{2}-\d{2}T/
const NUMBER_PATTERN = /^-?\d+\.?\d*$/
const LONG_TEXT_THRESHOLD = 80

/**
 * Infer the field type from dataType metadata, label, and actual value.
 * Returns: 'boolean' | 'date' | 'datetime' | 'currency' | 'number'
 *        | 'dropdown' | 'multiselect' | 'longtext' | 'text'
 */
export const inferFieldType = (value, label, dataType) => {
  const dt = (dataType || '').toLowerCase()
  const lbl = (label || '').toLowerCase()

  // Explicit dataType from API metadata
  if (dt === 'boolean' || dt === 'bit') return 'boolean'
  if (dt === 'datetime' || dt === 'date/time') return 'datetime'
  if (dt === 'date') return 'date'
  if (dt === 'currency' || dt === 'money') return 'currency'
  if (dt === 'number' || dt === 'int' || dt === 'integer' || dt === 'decimal' || dt === 'float' || dt === 'double') return 'number'
  if (dt === 'dropdown' || dt === 'list' || dt === 'picklist') return 'dropdown'
  if (dt === 'multiselect' || dt === 'multi-select') return 'multiselect'
  if (dt === 'richtext' || dt === 'html' || dt === 'memo') return 'longtext'
  if (dt === 'lookup') return 'text'

  // Infer from actual value
  if (typeof value === 'boolean') return 'boolean'
  if (typeof value === 'number') {
    return CURRENCY_LABELS.test(lbl) ? 'currency' : 'number'
  }
  if (typeof value === 'string') {
    if (DATETIME_PATTERN.test(value)) return 'datetime'
    if (DATE_PATTERN.test(value) && lbl.includes('date')) return 'date'
    if (NUMBER_PATTERN.test(value) && CURRENCY_LABELS.test(lbl)) return 'currency'
    if (NUMBER_PATTERN.test(value) && (lbl.includes('hour') || lbl.includes('qty') || lbl.includes('quantity') || lbl.includes('count'))) return 'number'
    if (value.length > LONG_TEXT_THRESHOLD) return 'longtext'
  }

  // Infer from label patterns
  if (lbl.includes('date') || lbl.includes('created') || lbl.includes('modified')) {
    if (typeof value === 'string' && DATE_PATTERN.test(value)) return 'date'
  }
  if (lbl.includes('is ') || lbl.includes('has ') || lbl.startsWith('is') || lbl.startsWith('has') || lbl.includes('enable') || lbl.includes('allow')) {
    if (value === 'True' || value === 'False' || value === true || value === false) return 'boolean'
  }

  return 'text'
}

export const fmtValue = (val, label, dataType) => {
  if (val == null || val === '') return '--'
  const ft = inferFieldType(val, label, dataType)
  switch (ft) {
    case 'boolean': return (val === true || val === 'True') ? 'Yes' : 'No'
    case 'date': return dayjs(val).format('M/D/YYYY')
    case 'datetime': return dayjs(val).format('M/D/YYYY h:mm A')
    case 'currency': return `$${Number(val).toLocaleString('en-US', { minimumFractionDigits: 2 })}`
    case 'number': return Number(val).toLocaleString('en-US')
    default: return String(val)
  }
}
